module.exports = __webpack_public_path__ + "static/media/nvshen-riyongpin.b7e40f97.png";